/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IScrollablePaneStyles } from '@fluentui/react/lib/ScrollablePane';
import { IStackItemStyles, IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            backgroundColor: theme.palette.neutralLighterAlt,
            height: '100vh',
            margin: 0,
            overflowY: 'auto',
        },
    };
};

export const getScrollablePaneStackItemStyles = (): Partial<IStackItemStyles> => {
    return {
        root: {
            position: 'relative',
            height: '100%',
            width: '100%',
        },
    };
};

export const getScrollablePaneStyles = (): Partial<IScrollablePaneStyles> => {
    return {
        root: {
            overflow: 'auto',
        },
        contentContainer: {
            padding: '0 1.75rem',
        },
    };
};
